import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython, faMicroblog } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Papers.scss';
import { faBrain, faMicrochip } from "@fortawesome/free-solid-svg-icons";


function Papers() {
        return (
    <div className="container" id="papers">
        <div className="pub-container">
            <h1>Publications</h1>
                <div className="pub-grid">

                    <div className="pub-inset">
                            <h4>Three-Terminal Memristor with Tunable Volatility and Set Voltage</h4>
                            <p>
                                <span className="italic" style={{ fontStyle: 'italic' }}>Kshipra Srikrishnaprabhu, Mila Lewerenz, Markus Fischer, Elias Passerini, Arnaud Schneuwly, Nadia Jimenez Olalla, Raphael Gisler, </span><span className="bold" style={{fontWeight: 9999 }}>Martin Stecher,</span> <span className="italic" style={{ fontStyle: 'italic' }}>Alexandros Emboras, Mathieu Luisier, Miklós Csontos, Juerg Leuthold.</span>
                            </p>
                            <p>
                                Advanced Electronic Materials, November 3 2025
                            </p>
                            <a href="https://doi.org/10.1002/aelm.202500362" target="_blank" rel="noreferrer">→ view the paper</a>
                    </div>

                    <div className="pub-inset">
                            <h4>Gap-Seeded Nucleation of Single Ag Nanoparticles for Filamentary Memristors</h4>
                            <p>
                                <span className="italic" style={{ fontStyle: 'italic' }}>Markus Fischer-Butesheva, David Eglin, Mila Lewerenz, Gian-Luca Franchini, Elias Passerini, Nadia Jimenez Olalla, Kshipra Srikrishnaprabhu, </span><span className="bold" style={{fontWeight: 9999 }}>Martin Stecher,</span> <span className="italic" style={{ fontStyle: 'italic' }}>Raphael Gisler, Yuriy Fedoryshyn, Miklós Csontos, Juerg Leuthold.</span>
                            </p>
                            <p>
                                Advanced Electronic Materials, May 25 2026
                            </p>
                            <a href="https://doi.org/10.1002/aelm.70437" target="_blank" rel="noreferrer">→ view the paper</a>
                    </div>

                    <div className="pub-inset">
                            <h4>Filamentary Memristors for Potential Applications in Optoelectronic Neuromorphic Networks</h4>
                            <p>
                                <span className="italic" style={{ fontStyle: 'italic' }}>Markus Fischer-Butesheva, David Eglin, Mila Lewerenz, Gian-Luca Franchini, Elias Passerini, Nadia Jimenez Olalla, Kshipra Srikrishnaprabhu, </span><span className="bold" style={{fontWeight: 9999 }}>Martin Stecher,</span> <span className="italic" style={{ fontStyle: 'italic' }}>Raphael Gisler, Yuriy Fedoryshyn, Miklós Csontos, Juerg Leuthold.</span>
                            </p>
                            <p>
                                European Conference on Integrated Optics (ECIO), June 15–17 2026
                            </p>
                            <a href="https://opg.optica.org/abstract.cfm?uri=ECIO-2026-T2C.1" target="_blank" rel="noreferrer">→ view the paper</a>
                    </div>
                </div>
        </div>
    </div>
    );
}
export default Papers;